<script setup lang="ts">
</script>
<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We welcome feedback. Please use the feedback function via button available after entering your sports betting query within the app.</p>
  </div>
</template>